import { useState } from "react";
import axios from "axios";

function EditDesignation({designation,onClose}){

const [designationName,setDesignationName]=useState(
designation.designation_name
);

const [description,setDescription]=useState(
designation.description || ""
);

const updateDesignation=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=await axios.post(

"https://saleupcall.com/api/Designation/edit-designation.php",

{

id:designation.id,

designation_name:designationName,
description

},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Designation Updated"
);

onClose();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={updateDesignation}>

<div className="row">

<div className="col-md-12 mb-3">

<input
className="form-control form-control-sm"
placeholder="Designation Name"
value={designationName}
onChange={(e)=>
setDesignationName(
e.target.value
)
}
/>

</div>

<div className="col-md-12 mb-3">

<textarea
className="form-control form-control-sm"
rows="3"
placeholder="Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
/>

</div>

</div>

<div className="text-end">

<button
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Update

</button>

</div>

</form>

);

}

export default EditDesignation;